import React from 'react'

import { RichTextAttributeStyle } from 'features/views/attributes/editable/RichTextAttribute.css'
import { RichTextValue } from 'features/views/attributes/types'

import { Textarea } from 'ui/components/Textarea'

import { useSectionRichTextAttributeEditorState } from './hooks/useSectionRichTextAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionRichTextAttributeEditorProps = SectionAttributeEditorProps<RichTextValue | null>

export const SectionRichTextAttributeEditor: React.FC<SectionRichTextAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
    placeholder,
}) => {
    const { localValue, handleChange, editorRef } = useSectionRichTextAttributeEditorState({
        value,
        onChange,
    })

    return (
        <Textarea
            ref={editorRef}
            richText={true}
            size="m"
            label={label}
            value={localValue}
            onChange={handleChange}
            readOnly={isReadOnly}
            resizable
            className={RichTextAttributeStyle}
            style={{
                maxHeight: '300px',
            }}
            placeholder={placeholder}
        />
    )
}
